// extracted by mini-css-extract-plugin
module.exports = {"outer":"_2tmfG","information":"mFTa2"};